export default "__VITE_ASSET__be14574c__"